import { deleteResearcher, postSearchResearcher, putResultExResearcher } from '../../../services/um/umServiceURL'
import useCallApi from '../../../utilities/axios'

export type TempPasswordRequest = {
    password: string
    startDate?: string
    endDate?: string
}

const useResearcherHook = () => {
    const callApi = useCallApi()

    const searchResearcher = async (keyword?: string, rowPerPage = 10) => {
        const response = await callApi.axiosPost({
            url: postSearchResearcher,
            params: {
                keyword: keyword ?? null,
                pageNo: 1,
                rowPerPage,
            },
        })
        return response?.data
    }

    const deleteResearcherByID = async (userID?: number) => {
        const response = await callApi.axiosDelete({
            url: `${deleteResearcher}/${userID}`,
        })
        return response?.data
    }

    const getResearcherById = async (userId: number) => {
        const response = await callApi.axiosGet({
            url: `${putResultExResearcher}/${userId}`,
        })
        return response?.data
    }

    const updateTempPassword = async (userId: number, value: TempPasswordRequest) => {
        const response = await callApi.axiosPut({
            url: `${putResultExResearcher}/${userId}/temp-password`,
            params: value,
        })
        return response?.data
    }

    return {
        searchResearcher,
        deleteResearcherByID,
        getResearcherById,
        updateTempPassword,
    }
}

export default useResearcherHook
